import { useEffect, type RefObject } from 'react';

/**
 * コーチマークが表示中に、対象要素がクリックされたら自動で閉じるフック
 */
export function useCoachMarkDismiss(
  targetRef: RefObject<HTMLElement | null>,
  visible: boolean,
  onDismiss: () => void,
) {
  useEffect(() => {
    if (!visible || !targetRef.current) return;
    const el = targetRef.current;
    el.addEventListener('click', onDismiss);
    return () => el.removeEventListener('click', onDismiss);
  }, [visible, onDismiss]);
}
